import { useContext } from "react";
import TemplateContext from "@/context/Template/TemplateContext";

export const TagDescription = () => {

    const dataContext = useContext(TemplateContext);
    const { content: formatContent } = dataContext || {};

    return (
        <>
            <h1 className="tag-title">{formatContent?.title}</h1>
            {!!formatContent?.description && (
              <div
                className="tag-description"
                suppressHydrationWarning
                dangerouslySetInnerHTML={{
                  __html: formatContent.description.replace(/_/g, "-"),
                }}
              />
            )}
        </>
    );


}